var mq = function mq(breakpoint) {
  return function (theme) {
    return theme.breakpoints ? "@media (min-width: ".concat(theme.breakpoints[breakpoint], ")") : null;
  };
};

export var media = {
  mobile: mq('mobile'),
  tablet: mq('tablet'),
  desktop: mq('desktop')
};